import PropTypes from "prop-types"
import React, { useState } from "react"
import {
  Row,
  Col,
  Alert,
  Card,
  CardBody,
  Container,
  FormFeedback,
  Input,
  Label,
} from "reactstrap"

//redux
import { Link } from "react-router-dom"
import withRouter from "components/Common/withRouter"

// Formik Validation
import * as Yup from "yup"
import { Formik, Form } from "formik"

// import images
import profile from "../../assets/images/profile-img.png"
import logo from "../../assets/images/logo-sm.png"
import FormikInputField from "helpers/FormikInputField"
import { useLoading } from "helpers/custom_hooks"
import { ResetPassword } from "helpers/backend_helper"
import { displayMessage } from "helpers/misc_helpers"

const ForgetPasswordPage = props => {
  const setLoading = useLoading()
  const [error, setError] = useState()
  const [success, setSuccess] = useState()

  const initialValues = {
    email: "",
  }

  const validationSchema = Yup.object({
    email: Yup.string().required("Please Enter Your Email"),
  })

  const handleSubmit = async values => {
    try {
      setLoading(true)
      await ResetPassword(values)
      setSuccess(true)
    } catch (err) {
      setLoading(false)

      err?.response?.status == 400
        ? displayMessage(err.response.data, setError)
        : displayMessage("An unhandled exception happend!", setError)
    }
    setLoading(false)
  }

  return (
    <React.Fragment>
      <div className="home-btn d-none d-sm-block">
        <Link to="/" className="text-dark">
          <i className="bx bx-home h2" />
        </Link>
      </div>
      <div className="account-pages my-5 pt-sm-5">
        <Container>
          <Row className="justify-content-center">
            <Col md={8} lg={6} xl={5}>
              <Card className="overflow-hidden">
                <div className="bg-primary bg-softbg-soft-primary">
                  <Row>
                    <Col xs={7}>
                      <div className="text-primary p-4">
                        <h5 className="text-primary">Welcome Back !</h5>
                        <p>Sign in to continue to chipsconnect.</p>
                      </div>
                    </Col>
                    <Col className="col-5 align-self-end">
                      <img src={profile} alt="" className="img-fluid" />
                    </Col>
                  </Row>
                </div>
                <CardBody className="pt-0">
                  <div>
                    <Link to="/">
                      <div className="avatar-md profile-user-wid mb-4">
                        <span className="avatar-title rounded-circle bg-light">
                          <img
                            src={logo}
                            alt=""
                            className="rounded-circle"
                            height="34"
                          />
                        </span>
                      </div>
                    </Link>
                  </div>
                  <div className="p-2">
                    <Formik
                      initialValues={initialValues}
                      validationSchema={validationSchema}
                      onSubmit={handleSubmit}
                    >
                      {({ errors, touched }) => (
                        <Form>
                          {error ? <Alert color="danger">{error}</Alert> : null}
                          {success ? (
                            <Alert color="success">
                              We have sent you an email! Please check your
                              inbox!
                            </Alert>
                          ) : null}

                          <FormikInputField
                            fieldName="email"
                            fieldType="email"
                            label="Email"
                            errors={errors}
                            touched={touched}
                          />

                          <div className="mt-3 d-grid">
                            <button
                              className="btn btn-primary btn-block"
                              type="submit"
                            >
                              Reset Password
                            </button>
                          </div>
                        </Form>
                      )}
                    </Formik>
                  </div>
                </CardBody>
              </Card>
              <div className="mt-5 text-center">
                <p>
                  Go back to{" "}
                  <Link to="/login" className="font-weight-medium text-primary">
                    Login
                  </Link>{" "}
                </p>
                <p>© {new Date().getFullYear()} chipsconnect</p>
              </div>
            </Col>
          </Row>
        </Container>
      </div>
    </React.Fragment>
  )
}

ForgetPasswordPage.propTypes = {
  history: PropTypes.object,
}

export default withRouter(ForgetPasswordPage)
